import { createContext } from '@lit/context'
import { BREAKPOINT } from '../util/breakpoints'

export const breakpointContext = createContext<BREAKPOINT>(Symbol('breakpoint'))
